import { emailKey, type MemberAggregate } from "@ext/enterprise/components/admin/settings/members/model/Member";
import { useMemo } from "react";

interface UseEditorSlotStatusArgs {
	email: string;
	isEditor: boolean;
	aggregate: MemberAggregate;
}

export const useEditorSlotStatus = ({ email, isEditor, aggregate }: UseEditorSlotStatusArgs) => {
	const wasEditor = Boolean(aggregate.usersByValue.get(emailKey(email))?.isEditor);
	const editorSlotsFull = !wasEditor && aggregate.editors.length >= aggregate.editorsCount;

	const effectiveEditorsUsed = useMemo(() => {
		const base = wasEditor ? aggregate.editors.length - 1 : aggregate.editors.length;
		return isEditor ? base + 1 : base;
	}, [isEditor, aggregate.editors.length, wasEditor]);

	return { wasEditor, editorSlotsFull, effectiveEditorsUsed };
};
